import { dialog } from 'app/utils';
import { API, APIClient } from 'app/utils/client';
import i18n from 'app/i18n';
import { IModel, IResponse } from 'app/models';

export class LookupService<T extends IModel> {
  public constructor(
    private client: APIClient,
    private path: string,
  ) { }

  private async intercept(promise: Promise<IResponse<T>>): Promise<IResponse<T>> {
    return promise.then((response) => {
      const { success, errors } = response;
      if (!success) errors?.forEach(({ code, message }) => {
        dialog.toast({ severity: 'error', title: i18n.t(`app.errors.${code}`), message });
      });

      return response;
    });
  }

  public async query(path: string, params?: any) {
    return this.intercept(this.client.get<IResponse<T>>(`${this.path}/${path}`, { params }));
  }
}

const instance = new LookupService(API, 'v1');
export default instance;
